<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf = "usuario && usuario.sucesso" class="panel panel-default bg-white-detail form-filtrar form-default PADRAO">
    <h3><strong>Detalhe da transação</strong></h3>

    <button type="button" mat-icon-button style="top: -10px; right: -10px; position: absolute;" matTooltip="Fechar" (click)="fechar()">
        <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
        </mat-icon>
    </button>
    <div class="panel-body" [hidden]="ocultarDadosDetalhes">
        <div class="row">
            <div class="col-md-3 dados-detalhes-linha">
                <div class="col-md-6 ">
                    <span class="dados-detalhes-label-transacao">Transação:</span><br />
                    <span class="dados-detalhes-codigo-transacao">{{ dados.coD_TRANSACAO }}</span>
                </div>
                <div class="col-md-6" *ngIf="dados.situacao == 'Efetuada'">
                    <span class="transacao-status transacao-aprovada">APROVADA</span>
                </div>
                <div class="col-md-6" *ngIf="dados.situacao == 'Rejeitada'">
                    <span class="transacao-status transacao-negada">NEGADA</span>
                </div>
            </div>
            <div class="col-md-9" *ngIf="dados.situacao == 'Rejeitada'">
                <span class="transacao-negada-descricao">{{ dados.coD_ERRO }} -  {{dados.dsC_MENSAGEM_RETORNO}}</span>
            </div>
        </div>
        <div class="row dados-linha-detalhes">
            <div class="col-md-3 ">
                <label>Placa</label>
                <span class="dados-detalhes">{{ dados.dsC_PLACA }}</span>
            </div>
            <div class="col-md-6 ">
                <label>Motorista</label>
                <span class="dados-detalhes">{{ dados.dsC_NOME }}</span>
            </div>
            <div class="col-md-3 ">
                <label>CPF</label>
                <span class="dados-detalhes">{{ dados.nuM_CPF | cpfFormat}}</span>
            </div>
        </div>
        <div class="row dados-linha-detalhes">
            <div class="col-md-3 ">
                <label>Data</label>
                <span class="dados-detalhes">{{ dados.daT_ABASTECIMENTO | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
            </div>
            <div class="col-md-3 ">
                <label>Nº abastecimento</label>
                <span class="dados-detalhes">{{ dados.coD_ABASTECIMENTO }}</span>
            </div>
            <div class="col-md-3 ">
                <label>Pagamento</label>
                <span class="dados-detalhes">{{ dados.dsC_TIPOPRODUTO }}</span>
            </div>
            <div class="col-md-3 ">
                <label>Valor do abastecimento</label>
                <span class="dados-detalhes">{{ dados.vlR_TOTAL | currency:'BRL':'symbol':'1.2-2' }}</span>
            </div>
        </div>
        <div class="row dados-linha-detalhes">
            <div class="col-md-3 ">
                <label>Saldo atual</label>
                <span class="dados-detalhes"></span>
            </div>
            <div class="col-md-3 ">
                <label>Combustível</label>
                <span class="dados-detalhes">{{ dados.zE_DESCRIC }}</span>
            </div>
            <div class="col-md-3 ">
                <label>Litros</label>
                <span class="dados-detalhes">{{ dados.qtD_VOLUME | number:'1.2-2' }}</span>
            </div>
            <div class="col-md-3 ">
                <label>Valor litro</label>
                <span class="dados-detalhes">{{ dados.vlR_UNITARIO_DESCONTO | currency:'BRL':'symbol':'1.2-2'}}</span>
            </div>
        </div>
        <div class="row dados-linha-detalhes">
            <div class="col-md-3 ">
                <label>KM por litro</label>
                <span class="dados-detalhes">{{ dados.kM_POR_LITRO | number:'1.2-2'}}</span>
            </div>
            <div class="col-md-3 ">
                <label>Hodômetro digitado</label>
                <span class="dados-detalhes">{{ dados.nuM_KM  }}</span>
            </div>
            <div class="col-md-3 ">
                <label>Hodômetro anterior</label>
                <span class="dados-detalhes"></span>
            </div>
            <div class="col-md-3 ">
                <label>Listros por hora</label>
                <span class="dados-detalhes"></span>
            </div>
        </div>
        <div class="row dados-linha-detalhes">
            <div class="col-md-3 ">

            </div>
            <div class="col-md-3 ">
               <div
                    *ngIf="temImagemOdometro"
                    class="div-vertical-center-left"
                    style="max-height: 40px; cursor: pointer;"
                    (click)="verImagemTransacao()">

                    <img src="assets/icons/cam-ocr.svg"
                        alt="Ícone câmera"
                        style="width: 32px; height: 32px; margin-right: 8px;" />

                    <span class="camera-cor" style="font-weight: 500;text-decoration: underline;">Imagem do Hodômetro</span>
                </div>
            </div>
            <div class="col-md-3 text-center">
                <button type="button" class="btn btn-secondary btn-submit btn-acao-ajustar-regra" [title]="byPass == false ? 'By pass não habilitado para esse retorno' : ''" [disabled]="byPass == false" (click)="chamarByPass()">
                    Bypass
                </button>
            </div>
            <div class="col-md-3 text-center">
                <button type="button" class="btn btn-primary btn-submit btn-acao-ajustar-regra" [disabled]="acaoRapida == false" (click)="chamarAjusteRegra()">
                    {{ textoBtnDetalhe == '' ? 'AJUSTAR REGRA' : textoBtnDetalhe }}
                </button>
            </div>
        </div>
    </div>

    <div [hidden]="!ocultarDadosDetalhes">
        <iframe [src]="url_redirect" width="100%" height="600" frameborder="0"></iframe>
    </div>
</div>

<!-- Dialog customizada para exibir imagem do hodômetro -->
<div
  class="custom-dialog-overlay"
  *ngIf="mostrarImagemTransacao"
  (click)="fecharImagemTransacao()"
>
  <div class="custom-dialog-content" (click)="$event.stopPropagation()">
    <h4>Imagem do Hodômetro</h4>
    <img
      *ngIf="imagemTransacao?.retorno?.imG_BASE64"
      [src]="'data:image/jpeg;base64,' + imagemTransacao.retorno?.imG_BASE64"
      alt="Imagem do Hodômetro"
      style="max-width: 100%; max-height: 500px; object-fit: contain;"
    />
    <button style="margin-top: 20px;" type="button" class="btn btn-secondary" (click)="fecharImagemTransacao()">Fechar</button>
  </div>
</div>
